export enum DocumentStateType {
    Unknown,
    Active,
    Inactive,
    Deleted
}
